export const homeCover = {
  top_text: 'Nur Heute',
  sale_percent: 'Bis zu 50%',
  title: `Tag der Eltern-Wertschätzung`,
  sub_title: `SALE`,
  sub_title_date: '11.22',
  description: `Nur die besten Geschenke für Mama und Papa. Weil sie unsere warmherzige Wertschätzung verdienen.`,
  handle: `/collections/sale`,
  imgLeft: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/cl_22.png?v=1605952610`,
  imgRight: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/cr_22.png?v=1605952610`,
};

export const homeCoverSecond = {
  top_text: 'Nur Heute',
  sale_percent_text: 'BIS ZU',
  sale_percent_number: '50',
  sale_percent_off: 'OFF',
  title: `Welt-Hallo-Tag`,
  description: `Senden Sie Ihren Lieben herzliche Grüße mit GOBI.`,
  handle: `/collections/sale`,
  imgLeft: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/cover21.jpg?v=1605853534`,
  imgRight: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/cover21-sub.jpg?v=1605853533`,
};

export const homeData1 = {
  title: 'MINERAL HW20-KOLLEKTION',
  handle: '/collections/mineral',
  desktopImgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/top-img_new.jpg?v=1603963100',
  mobileImgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/top-imgdd-mobile_new.jpg?v=1603963100',
};

export const homeData2 = [
  {
    title: 'HOSEN & RÖCKE',
    handle: '/collections/damen-hosen-rocke',
    sale_txt: '',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/item1_22.jpg?v=1605952610',
  },
  {
    title: 'SCHALS',
    handle: '/collections/schals',
    sale_txt: 'Bis zu 50%',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/item2_22.jpg?v=1605952610',
  },
  // {
  //   banner: true,
  //   title: 'DECKEN',
  //   handle: '/collections/wohnen-decken',
  //   sale_title: 'SALE',
  //   sale_date: '11.20',
  //   sale_percent_text: 'BIZ SU',
  //   sale_percent_number: '30',
  //   sale_percent_off: 'OFF',
  // },
  {
    title: 'BLAZER',
    handle: '/collections/herren-mantel',
    sale_txt: '',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/item3_22.jpg?v=1605952610',
  },
];

export const homeData3 = [
  {
    title: 'HERREN',
    handle: '/collections/herren',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/men-new.jpg?v=1604998196',
    style: 'img-anim4-left',
  },
  {
    title: 'DAMEN',
    handle: '/collections/damen',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0473/8377/3350/files/women-new.jpg?v=1604998196',
    style: 'img-anim4-right',
  },
];

export const homeData4 = [
  {
    title: 'ACCESSOIRES FÜR DEN HERBST',
    handle: '/collections/winter-spice-accessoires',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/newAcc1.jpg?v=1600336543',
  },
  {
    title: 'GEMÜTLICHES ZUHAUSE',
    handle: '/collections/wohnen',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/acc2-edit.jpg?v=1600757049',
  },
];

export const homeData5 = {
  title: 'PAINTBOX AW20',
  handle: '/collections/paintbox',
  desktopImgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/home_top-img.jpg?v=1598288382',
  mobileImgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/m_home_top_img.jpg?v=1598289790',
};

export const homeData6 = [
  {
    title: 'GOBI ORGANIC KOLLEKTION',
    description:
      'GOBI stellt den Organic-Kaschmir ins Rampenlicht. Die Kollektion aus nachhaltigen und organischen Kaschmirfasern  hat vier natürlichen Farben der Mongolischen Kaschmirziegen.',
    handle: '/pages/organic2020',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask-Group3.jpg?v=1600215620',
    imgChild: [
      {
        imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask-Group1.jpg?v=1600215620',
      },
      {
        imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask-Group.jpg?v=1600215620',
      },
      {
        imgSrc: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask-Group2.jpg?v=1600215620',
      },
    ],
  },
];

export const homeData7 = {
  title: 'UNSERE GESCHICHTE',
  description: 'Enthüllen Sie, wie GOBI der größte Kaschmirladen der Welt wurde.',
  handle: '/pages/wer-wir-sind',
  imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/worldnumberone.jpg?v=1602234018',
};

export const home_gifts = [
  {
    keyIndex: '1',
    title: 'Socken, Mütze oder Webschal',
    handle: '/pages/gift',
    price: '89',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-01.jpg?v=1600831011',
    alt: 'Socken, Mütze oder Webschal',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-01.jpg?v=1601258860',
      },
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-02.jpg?v=1601258861',
      },
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-03.jpg?v=1601258860',
      },
    ],
  },
  {
    keyIndex: '2',
    title: 'Fransenschal',
    handle: '/pages/gift',
    price: '199',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-02.jpg?v=1600831011',
    alt: 'Fransenschal',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-04.jpg?v=1601258860',
      },
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-05.jpg?v=1601258860',
      },
    ],
  },
  {
    keyIndex: '3',
    title: 'Dreieck-Schal oder kariertes Tuch',
    handle: '/pages/gift',
    price: '299',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-03.jpg?v=1600831011',
    alt: 'Dreieck-Schal oder kariertes Tuch',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-06.jpg?v=1601258861',
      },
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-07.jpg?v=1601258861',
      },
    ],
  },
  {
    keyIndex: '4',
    title: 'Webdecke',
    handle: '/pages/gift',
    price: '399',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-04.jpg?v=1600831011',
    alt: 'Webdecke',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-09.jpg?v=1601258861',
      },
    ],
  },
  {
    keyIndex: '5',
    title: 'Gestrickte Decke',
    handle: '/pages/gift',
    price: '499',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-05.jpg?v=1600831011',
    alt: 'Gestrickte Decke',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-11.jpg?v=1601258861',
      },
    ],
  },
  {
    keyIndex: '6',
    title: 'Strickdecke & Socken',
    handle: '/pages/gift',
    price: '599',
    imgSrc: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-06.jpg?v=1600831011',
    alt: 'Strickdecke & Socken',
    child: [
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-12.jpg?v=1601258860',
      },
      {
        img_Url: 'https://cdn.shopify.com/s/files/1/1953/2845/files/gifts-add-13.jpg?v=1601258860',
      },
    ],
  },
];

export const shopNowText = {
  title: 'Jetzt entdecken',
};

export const discoverText = {
  title: 'Entdecken',
};
